export default {
    data () {
      return {
      };
    },
    methods: {
        downloadFile(response, title, fileType) {
            const link = document.createElement('a');
            link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent('\uFEFF' + response.data);
            link.target = '_blank';
            link.download = `${title}.${fileType}`;
            link.click();
        }
    },
  };
